<template>
    <v-container>
      <!-- 頂部操作列 -->
      <div class="d-flex align-center mb-6">
        <v-text-field
          v-model="search"
          prepend-inner-icon="mdi-magnify"
          placeholder="請輸入姓名或班級或學生資料"
          outlined
          dense
          hide-details
          class="flex-grow-1 mr-4"
        ></v-text-field>
        
        <v-btn
          color="black"
          dark
          class="mr-2"
          @click="downloadCSV"
        >
          下載CSV
        </v-btn>
        
        <v-btn
          color="black"
          dark
          @click="addStudent"
        >
          新增帳號
        </v-btn>
      </div>
  
      <!-- 學生列表 -->
      <div v-for="(group, index) in filteredStudentGroups" :key="index">
        <div class="d-flex align-center my-4">
          <div class="text-h6 font-weight-bold text-left">{{ group.categoryName }}</div>
          <v-divider class="flex-grow-1 ml-2"></v-divider>
        </div>
        
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th>姓名</th>
                <th>帳號</th>
                <th>密碼</th>
                <th>信箱</th>
                <th class="text-right">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="student in group.students" :key="student.id">
                <td class="text-left">{{ student.name }}</td>
                <td class="text-left">{{ student.username }}</td>
                <td class="text-left">{{ student.password }}</td>
                <td class="text-left">{{ student.email }}</td>
                <td class="text-right">
                  <v-icon
                    small
                    class="mr-2"
                    @click="editStudent(student)"
                  >
                    mdi-pencil
                  </v-icon>
                  <v-icon
                    small
                    @click="deleteStudent(student)"
                  >
                    mdi-delete
                  </v-icon>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
  
      <!-- Add this dialog component -->
      <v-dialog v-model="deleteDialog" max-width="300">
        <v-card>
          <v-card-title class="text-h6">
            確定要刪除帳號嗎?
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              text
              @click="deleteDialog = false"
            >
              取消
            </v-btn>
            <v-btn
              color="error"
              text
              @click="confirmDelete"
            >
              刪除
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <!-- Add Account Dialog -->
      <v-dialog v-model="addDialog" max-width="1000">
        <v-card>
          <v-card-title class="text-h6">
            選擇班級資訊
          </v-card-title>
          
          <v-card-text>
            <v-row>
              <v-col cols="4">
                <div class="d-flex">
                  <v-select
                    v-model="newAccount.classYear"
                    :items="classYears"
                    label="級別"
                    item-text="name"
                    item-value="_id"
                    return-object
                    outlined
                    dense
                    class="flex-grow-1 mr-2"
                  ></v-select>
                  <v-btn
                    icon
                    small
                    color="black"
                    @click="openAddClassYearDialog"
                    style="margin-top: 6px;"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </div>
              </v-col>
              <v-col cols="4">
                <v-select
                  v-model="newAccount.department"
                  :items="departmentsList"
                  label="系所"
                  item-text="name"
                  item-value="_id"
                  return-object
                  outlined
                  dense
                ></v-select>
        
              </v-col>
              <v-col cols="4">
                <div class="d-flex">
                <v-select
                  v-model="newAccount.classGroup"
                  :items="classGroups"
                  label="班級"
                  item-text="name"
                  item-value="_id"
                  return-object
                  outlined
                  dense
                  ></v-select>
                  <v-btn
                    icon
                    small
                    color="black"
                    @click="openAddClassGroupDialog"
                    style="margin-top: 6px;"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </div>
              </v-col>
            </v-row>

            <v-row align="center" class="mb-4">
              <v-col cols="2">
                <v-btn small icon @click="decrementCount">
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </v-col>
              <v-col cols="8">
                <v-text-field
                  v-model="accountCount"
                  type="number"
                  outlined
                  dense
                  hide-details
                  class="text-center"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="2">
                <v-btn small icon @click="incrementCount">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th>姓名</th>
                    <th>帳號</th>
                    <th>密碼</th>
                    <th>信箱</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="i in parseInt(accountCount)" :key="i">
                    <td class="text-left">{{ newAccounts[i-1].name }}</td>
                    <td class="text-left">{{ newAccounts[i-1].username }}</td>
                    <td class="text-left">{{ newAccounts[i-1].password }}</td>
                    <td class="text-left">{{ newAccounts[i-1].email }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              text
              @click="closeAddDialog"
            >
              取消
            </v-btn>
            <v-btn
              color="black"
              dark
              @click="confirmAdd"
            >
              新增
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <!-- Success Dialog -->
      <v-dialog v-model="successDialog" max-width="300">
        <v-card>
          <v-card-title class="text-h6 justify-center">
            新增帳號成功
          </v-card-title>
          <v-card-actions class="justify-center">
            <v-btn
              color="black"
              text
              @click="successDialog = false"
            >
              完成
            </v-btn>
            <v-btn
              color="black"
              dark
              @click="downloadAddedCSV()"
            >
              下載CSV檔
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
  
      <!-- Add Grade Dialog -->
      <v-dialog v-model="addClassYearDialog" max-width="400">
        <v-card>
          <v-card-title class="text-h6">
            新增級別
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="newClassYear"
              label="級別名稱"
              outlined
              dense
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              text
              @click="addClassYearDialog = false"
            >
              取消
            </v-btn>
            <v-btn
              color="black"
              dark
              @click="confirmAddClassYear()"
            >
              確認
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Add Class Group Dialog -->
      <v-dialog v-model="addClassGroupDialog" max-width="400">
        <v-card>
          <v-card-title class="text-h6">
            新增班級
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="newClassGroup"
              label="班級名稱"
              outlined
              dense
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="grey darken-1"
              text
              @click="addClassGroupDialog = false"
            >
              取消
            </v-btn>
            <v-btn
              color="black"
              dark
              @click="confirmAddClassGroup()"
            >
              確認
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

     <!-- Edit Teacher Dialog -->
      <v-dialog v-model="editDialog" max-width="1000">
        <v-card class="pa-6">
          <!-- Header Section -->
          <div class="d-flex align-center mb-8">
            <div>
              <div class="text-h5 font-weight-bold text-left">編輯學生資料</div>
              <div class="text-subtitle-1 grey--text text-left">{{ editingStudent.department.name }} - {{ editingStudent.classYear.name }} - {{ editingStudent.classGroup.name }}</div>
            </div>
            <v-spacer></v-spacer>
          </div>

          <!-- Profile Form -->
          <v-form>
            <v-row>
              <!-- 姓名 -->
              <v-col cols="12" md="4">
                <v-text-field v-model="editingStudent.name" label="姓名" outlined></v-text-field>
              </v-col>
              <!-- 帳號 -->
              <v-col cols="12" md="4">
                <v-text-field v-model="editingStudent.username" label="帳號" outlined></v-text-field>
              </v-col>
              <!-- 密碼 -->
              <v-col cols="12" md="4">
                <v-text-field v-model="editingStudent.password" label="密碼" outlined></v-text-field>
              </v-col>
              <!-- 信箱 -->
              <v-col cols="12" md="4">
                <v-text-field v-model="editingStudent.email" label="信箱" outlined></v-text-field>
              </v-col>
              <!-- 電話 -->
              <v-col cols="12" md="4">
                <v-text-field v-model="editingStudent.phone" label="電話" outlined></v-text-field>
              </v-col>
              <!-- 性別 -->
              <v-col cols="12" md="4">
                <v-select v-model="editingStudent.sex" :items="sexOptions" label="性別" outlined></v-select>


              </v-col>
              <!-- 學校 -->
              <v-col cols="12" md="4">
                <v-text-field v-model="school.name" label="學校" outlined readonly></v-text-field>
              </v-col>
              <!-- 系所 -->
              <v-col cols="12" md="4">
                <v-select
                  v-model="editingStudent.department"
                  :items="departmentsList"
                  label="系所"
                  item-text="name"
                  item-value="_id"
                  return-object
                  outlined
                ></v-select>
              </v-col>
              <!-- 級別 -->
              <v-col cols="12" md="4">
                <v-select
                  v-model="editingStudent.classYear"
                  :items="classYears"
                  label="級別"
                  item-text="name"
                  item-value="_id"
                  return-object
                  outlined
                ></v-select>
              </v-col>
              <!-- 班級 -->
              <v-col cols="12" md="4">
                <v-select
                  v-model="editingStudent.classGroup"
                  :items="classGroups"
                  label="班級"
                  item-text="name"
                  item-value="_id"
                  return-object
                  outlined
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
          <v-card-actions class="pt-6">
        <v-spacer></v-spacer>
        <v-btn color="black" dark height="44" @click="confirmEdit"
            style="border-radius: 10px;width: 15rem;">
            完成
        </v-btn>
        <v-spacer></v-spacer>
    </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
  </template>
  
  <script>
  import DepartmentService from '../../services/department.service';
  import UserService from '../../services/user.service';
  import ClassYearService from '../../services/classYear.service';
  import ClassGroupService from '../../services/classGroup.service';
  export default {
    name: 'StudentList',
    data() {
      return {
        school: {name:''},
        departmentsList: [],
        classYears: [],
        classGroups: [],
        search: '',
        studentGroups: [
        ],
        deleteDialog: false,
        studentToDelete: null,
        addDialog: false,
        editDialog: false,
        editingStudent: {
          name: '',
          username: '',
          password: '',
          email: '',
          phone: '',
          sex: '',
          department: {name:''},
          classYear: {name:''},
          classGroup: {name:''}
        },
        addClassYearDialog: false,
        newClassYear: '',
        addClassGroupDialog: false,
        newClassGroup: '',
        accountCount: 1,
        newAccount: {
          classYear: '',
          department: '',
          classGroup: '',
        },
        newAccounts: [],
        successDialog: false,
        addedStudents: [],
        sexOptions:['男','女','其他']
      }
    },
    mounted(){
      this.getUserInfo();
      this.getDepartment();
      this.getClassYear();
      this.getClassGroup();
      this.getStudentBySchool();
    },
    methods: {
      addStudent() {
        this.addDialog = true;
        this.newAccount = {
          classYear: '',
          department: '',
          classGroup: '',
        };
        this.initializeNewAccounts();
      },
      closeAddDialog() {
        this.addDialog = false;
        this.addedStudents = [];
        this.initializeNewAccounts();
      },

      editStudent(student) {
        this.editDialog = true;
        this.editingStudent = student;
        if(!student.department){
          this.editingStudent.department = {name:''};
        }
        if(!student.classYear){
          this.editingStudent.classYear = {name:''};
        }
        if(!student.classGroup){
          this.editingStudent.classGroup = {name:''};
        }
      },
      deleteStudent(student) {
        this.studentToDelete = student;
        this.deleteDialog = true;
      },
      confirmDelete() {
        UserService.deleteStudent(this.studentToDelete._id).then(() => {
          this.getStudentBySchool();
        });
        this.deleteDialog = false;
        this.studentToDelete = null;
      },
      openAddClassGroupDialog() {
        this.addClassGroupDialog = true;
        this.newClassGroup = '';
      },
      openAddClassYearDialog() {
        this.addClassYearDialog = true;
        this.newClassYear = '';
      },
      /////////////////////////api/////////////////////////
      getUserInfo(){
        UserService.getUserInfo(localStorage.getItem('user_id')).then(res => {
          this.school = res.data.school;
        });
      },
      getDepartment(){
        DepartmentService.getDepartmentsBySchool().then(res => {
          this.departmentsList = res;
        });
      },
      getClassYear(){
        ClassYearService.findBySchool().then(res => {
          this.classYears = res.data;
        });
      },
      getClassGroup(){
        ClassGroupService.findBySchool().then(res => {
          this.classGroups = res.data;
        });
      },
      getStudentBySchool(){
        UserService.getStudentBySchool().then(res => {
          this.studentGroups = res.data;
        });
      },
      confirmAddClassYear() {
        if (this.newClassYear.trim()) {
          ClassYearService.add({name:this.newClassYear}).then(() => {
            this.getClassYear(); // 重新獲取級別列表
          });
          this.addClassYearDialog = false;
          this.newClassYear = '';
        }
      },
      confirmAddClassGroup() {
        if (this.newClassGroup.trim()) {
          ClassGroupService.add({name:this.newClassGroup}).then(() => {
            this.getClassGroup(); // 重新獲取級別列表
          });
          this.addClassGroupDialog = false;
          this.newClassGroup = '';
        }
      },
      confirmAdd() {
        if(!this.newAccount.classYear||this.newAccount.classYear===''){
          alert("請選擇級別");
          return;
        }
        if(!this.newAccount.department||this.newAccount.department===''){
          alert("請選擇系所");
          return;
        }
        if(!this.newAccount.classGroup||this.newAccount.classGroup===''){
          alert("請選擇班級");
          return;
        }
        UserService.addStudentByTeacher(this.newAccount,this.newAccounts).then(() => {  
          this.closeAddDialog();
          this.successDialog=true;
          this.getStudentBySchool();
          this.addedStudents=this.newAccounts;
        });
      },
      confirmEdit(){
        if(this.editingStudent.username === '') {
          alert('帳號不能為空')
          return
        }
        if(this.editingStudent.password === '') {
          alert('密碼不能為空')
          return
        }
        UserService.updateStudent(this.editingStudent).then(() => {
          this.getStudentBySchool();
        });
        this.editDialog = false;
      },
      /////////////////////////util/////////////////////////      
      initializeNewAccounts() {
        this.newAccounts = Array(parseInt(this.accountCount)).fill().map(() => ({
          name: '',
          username: this.randomAccount(),
          password: this.randomPassword(),
          email: ''
        }));
      },
      randomAccount() {
        return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      },
      randomPassword() {
        return Math.random().toString(36).substring(2, 15);
      },
      incrementCount() {
        this.accountCount = parseInt(this.accountCount) + 1;
        this.initializeNewAccounts();
      },
      decrementCount() {
        if (this.accountCount > 1) {
          this.accountCount = parseInt(this.accountCount) - 1;
          this.initializeNewAccounts();
        }
      },downloadCSV() {
        // 準備 CSV 內容
        const headers = ['系所', '級別', '班級', '姓名', '帳號', '密碼', '信箱'];
        
        // 整理所有學生資料
        const allStudents = [];
        this.studentGroups.forEach(group => {
          const [department, classYear, classGroup] = group.categoryName.split(' - ');
          group.students.forEach(student => {
            allStudents.push([
              department,
              classYear,
              classGroup,
              student.name || '',
              student.username || '',
              student.password || '',
              student.email || ''
            ].join(','));
          });
        });

        const csvContent = [
          headers.join(','), // 標題行
          ...allStudents
        ].join('\n');

        // 創建 Blob 對象
        const blob = new Blob(['\ufeff' + csvContent], { 
          type: 'text/csv;charset=utf-8;' 
        });

        // 創建下載連結
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        
        // 設置下載文件名
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
        link.setAttribute('href', url);
        link.setAttribute('download', `所有學生帳號_${timestamp}.csv`);
        
        // 觸發下載
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
      downloadAddedCSV(){
        // 準備 CSV 內容
        const headers = ['系所', '級別', '班級', '姓名', '帳號', '密碼', '信箱'];
        const csvContent = [
          headers.join(','), // 標題行
          ...this.addedStudents.map(student => 
            [              
              this.newAccount.department.name,
              this.newAccount.classYear.name,
              this.newAccount.classGroup.name,
              student.name || '',
              student.username || '',
              student.password || '',
              student.email || ''
            ].join(',')
          )
        ].join('\n');

        // 創建 Blob 對象
        const blob = new Blob(['\ufeff' + csvContent], { 
          type: 'text/csv;charset=utf-8;' 
        });

        // 創建下載連結
        const link = document.createElement('a');
        const url = URL.createObjectURL(blob);
        
        // 設置下載文件名
        const timestamp = new Date().toISOString().replace(/[:.]/g, '-');
        link.setAttribute('href', url);
        link.setAttribute('download', `學生帳號_${timestamp}.csv`);
        
        // 觸發下載
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },


    },
    computed: {
      filteredStudentGroups() {
        if (!this.search) {
          return this.studentGroups;
        }

        const searchTerm = this.search.toLowerCase();
        
        return this.studentGroups.map(group => {
          // 過濾符合搜尋條件的學生
          const filteredStudents = group.students.filter(student => {
            return (
              (student.name && student.name.toLowerCase().includes(searchTerm)) ||
              (student.username && student.username.toLowerCase().includes(searchTerm)) ||
              (student.email && student.email.toLowerCase().includes(searchTerm)) ||
              (student.department && student.department.name && 
                student.department.name.toLowerCase().includes(searchTerm)) ||
              (student.classYear && student.classYear.name && 
                student.classYear.name.toLowerCase().includes(searchTerm)) ||
              (student.classGroup && student.classGroup.name && 
                student.classGroup.name.toLowerCase().includes(searchTerm))
            );
          });

          // 如果該組有符合的學生，返回修改後的組
          if (filteredStudents.length > 0) {
            return {
              ...group,
              students: filteredStudents
            };
          }
          return null;
        }).filter(group => group !== null); // 移除沒有符合學生的組
      }
    },
  }
  </script>
  
  <style scoped>
  .v-data-table ::v-deep th {
    font-weight: bold !important;
    color: rgba(0, 0, 0, 0.87) !important;
  }
  
  .v-data-table ::v-deep td {
    border-bottom: 1px solid #e0e0e0 !important;
  }
  
  .v-icon {
    cursor: pointer;
  }
  
  .v-icon:hover {
    opacity: 0.7;
  }
  </style> 